import template from './template.rt'
import './styles.css'

export const SectionTitle = props => template.call({ props })

export default SectionTitle
